module.exports = __webpack_public_path__ + "img/tips@2x.9454397d.png";